import { createI18n } from "vue-i18n";

import eng from '../locales/english.json';
import rus from '../locales/russian.json';
import uzb from '../locales/uzbek.json';

const locale = localStorage.getItem('locale')
if (!locale) localStorage.setItem('locale', 'rus');

const i18n = createI18n({
    //legacy: false, 
    fallbackLocale: 'rus',
    //availableLocales: [rus, uzb, eng],
    messages: { eng, rus, uzb }
});

export default i18n;
